import { passengerTitleEnum } from '../generated';

import type { ProductWithServices } from '../types';

export const getPartyCompositionFromProduct = (
  product: ProductWithServices | undefined,
): [number, number] => {
  const passengerPrices = product?.priceInformation?.passengerPrices ?? [];

  return passengerPrices.reduce(
    (composition, passenger) => {
      if (passenger.title === passengerTitleEnum.K) {
        return [composition[0], composition[1] + 1];
      }

      return [composition[0] + 1, composition[1]];
    },
    [0, 0],
  );
};
